module.exports = __webpack_public_path__ + "static/layer-3-square-4e7049837c14eceb9fce7322adacdb1a.svg";